module.exports = __webpack_public_path__ + "img/19.0aeb2654.jpg";